<div class="footer">
    <div>
        <div class="costs"
            [class.hidden]="hideCosts">
            <span class="costs__title">
<!--                Prijs-->
            </span>
            <span class="costs__price">
                <ig-currency [value]="orderService.total"
                    [sign]="false"
                    [sup]=true></ig-currency>
            </span>
            <span class="costs__text">
                Inclusief BTW en reiskosten. Exclusief materialen.
            </span>
        </div>
    </div>
    <span class="spacer"></span>
    <div class="footer__buttons">
        <ng-content></ng-content>
    </div>
</div>
